import type { CorsRule } from '@/entities/bucket';
import request from '@/shared/api/request';

export const getBucketCors = (name: string): Promise<{ cors_rules: CorsRule[] }> =>
  request({
    url: `/buckets/${name}/cors/`,
  });
